import { API_ROUTE_TRADE_IN_ORDERS } from '@/resources/api-routes'
import { get } from '@/util/auth'

const statuses = [
  'PRICE_REQUEST',
  'PRICE_ESTIMATION',
  'ACCEPTANCE',
  'SENT',
  'FINAL_PRICING',
  'FINISHED',
  'REJECTED',
] as const
export type Status = (typeof statuses)[number]

type Grade = 'A' | 'B'

type TradeInOrderOriginal = {
  orderId: string
  customerId: string
  customerName: string
  orderStatus: Status
  partnerId: string
  assetId: string
  productName: string | null
  assetDate: string | null
  finalGrade: Grade | null
  finalPrice: number | null
  imeiSerialNumber: string | null
  grade: Grade | null
  estimatedPrice: number | null
}

const IS_NEW_BACKEND_API = true

// eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
export const getTradeInOrders = async (customerId: number) => {
  const orders = await get<TradeInOrderOriginal[]>(
    `${API_ROUTE_TRADE_IN_ORDERS}?customerId=${customerId}`,
    IS_NEW_BACKEND_API
  )

  const orderCounter = orders.reduce<Record<Partial<Status | 'ALL'>, number>>(
    (acc, order) => {
      acc[order.orderStatus]++
      acc['ALL']++
      return acc
    },
    {
      ALL: 0,
      PRICE_REQUEST: 0,
      PRICE_ESTIMATION: 0,
      ACCEPTANCE: 0,
      SENT: 0,
      FINAL_PRICING: 0,
      FINISHED: 0,
      REJECTED: 0,
    }
  )
  return { orders, orderCounter }
}
